module.exports = __webpack_public_path__ + "img/bg7.c31f50eb.png";